<template>
  <b-field label="UF" expanded>
    <div class="filtro-uf-autocomplete">
      <b-autocomplete
        v-model="search"
        clearable
        expanded
        open-on-focus
        class="filtro-uf-autocomplete__control"
        :class="{ 'filtro-uf-autocomplete__control--todos': showTodos }"
        :placeholder="showTodos ? '' : 'UF'"
        :data="filteredOptions"
        @select="select"
        @clear="clear"
        @focus="onFocus"
        @blur="onBlur"
      >
        <template #empty>Nenhuma UF encontrada</template>
      </b-autocomplete>
      <span v-if="showTodos" class="filtro-uf-autocomplete__todos" aria-hidden="true">
        <span class="filtro-uf-autocomplete__tag">
          <span class="filtro-uf-autocomplete__tag-label">Todos</span>
        </span>
      </span>
    </div>
  </b-field>
</template>

<script>
export default {
  name: 'FiltroUfAutocomplete',
  props: {
    options: { type: Array, default: () => [] },
    value: { default: null },
    showTodosTag: { type: Boolean, default: true },
  },
  data() {
    return {
      search: '',
      focused: false,
      blurTimer: null,
    };
  },
  computed: {
    showTodos() {
      return (
        this.showTodosTag &&
        !this.focused &&
        (this.value == null || this.value === '') &&
        !String(this.search || '').trim()
      );
    },
    ufOptions() {
      return this.options.map(option => option.id || option.nome || option);
    },
    filteredOptions() {
      const term = String(this.search || '')
        .trim()
        .toLocaleLowerCase('pt-BR');
      if (!term) return this.ufOptions;
      return this.ufOptions.filter(uf => String(uf).toLocaleLowerCase('pt-BR').includes(term));
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.search = value || '';
      },
    },
  },
  beforeDestroy() {
    this.clearBlurTimer();
  },
  methods: {
    clearBlurTimer() {
      if (this.blurTimer) {
        clearTimeout(this.blurTimer);
        this.blurTimer = null;
      }
    },
    syncSearchFromValue() {
      this.search = this.value ? String(this.value).toUpperCase() : '';
    },
    onFocus() {
      this.clearBlurTimer();
      this.focused = true;
    },
    onBlur() {
      // Atrasa o reset da busca: o blur do input dispara antes do click na opção.
      // Sem o delay, a lista volta a começar em AC e o clique pega a primeira UF.
      this.blurTimer = setTimeout(() => {
        this.focused = false;
        this.blurTimer = null;
        this.syncSearchFromValue();
      }, 200);
    },
    select(uf) {
      this.clearBlurTimer();
      this.focused = false;
      if (!uf) {
        this.clear();
        return;
      }
      const selected = String(uf).toUpperCase();
      this.search = selected;
      this.$emit('input', selected);
    },
    clear() {
      this.clearBlurTimer();
      this.search = '';
      this.$emit('input', null);
    },
  },
};
</script>

<style lang="scss" scoped>
.filtro-uf-autocomplete {
  position: relative;
  width: 100%;
}

.filtro-uf-autocomplete__control ::v-deep .dropdown-menu {
  min-width: 100%;
  width: 100%;
}

.filtro-uf-autocomplete__todos {
  align-items: center;
  bottom: 0;
  display: flex;
  left: 0.75rem;
  pointer-events: none;
  position: absolute;
  right: 2.5rem;
  top: 0;
  z-index: 2;
}

.filtro-uf-autocomplete__tag {
  align-items: center;
  background: #f5f5f5;
  border-radius: 2px;
  color: #363636;
  display: inline-flex;
  font-size: 0.75rem;
  max-width: 100%;
  padding: 0.15rem 0.5rem;
}

.filtro-uf-autocomplete__tag-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filtro-uf-autocomplete__control--todos ::v-deep .input {
  caret-color: #363636;
  color: transparent;
}

// Mantém a cor do ícone no foco; escurece só no hover do próprio ícone.
.filtro-uf-autocomplete__control ::v-deep .control.has-icons-right {
  .input:focus ~ .icon,
  .input.is-focused ~ .icon,
  .input:active ~ .icon {
    color: #dbdbdb;
  }

  .icon.is-clickable:hover {
    color: #7a7a7a;
  }
}
</style>
